<template>
  <FormSelect
    v-if="options"
    v-model="modelValue"
    :items="options"
    :placeholder="t(`timetable.${props.id}`)"
  />
</template>

<script lang="ts" setup>
import type {
  TimetableFilterValue,
  TimetableSelectableFilterKey
} from '@/composables/useTimetableQuery'

const { t } = useI18n()
const props = defineProps<{
  id: TimetableSelectableFilterKey
  value: TimetableFilterValue
}>()

const emit = defineEmits<{
  (
    event: 'change',
    id: TimetableSelectableFilterKey,
    value: TimetableFilterValue
  ): void
}>()

const modelValue = computed({
  get: () => props.value,
  set: value =>
    emit('change', props.id, props.value === value ? undefined : value)
})

const { data: options } = useAsyncData(`${props.id}-filter`, async () => {
  const response =
    await useApi().publicPagesCourseAndEventsDatesFilterOptionsList({
      filter: props.id
    })

  return (response ?? []).filter(option => option.value !== null)
})
</script>
